import { Color, parseColor255 } from '@fe/core';
import { ChartPosition, Rect } from '../../util';
import { ShadeLayerSpecification, ShadeLineLayerSpecification } from '../chart-props';
import { getAxisRect } from '../helpers';
import { VectorDrawFunction } from './type';

export const drawShadeLineLayer: VectorDrawFunction<ShadeLineLayerSpecification> = (pass, features, layer, xAxis) => {
    const axisRect = getAxisRect(ChartPosition.top, pass);
    const shadeRect = new Rect([axisRect.left, axisRect.bottom], { width: axisRect.width, height: 6 }).translate(0, -10);

    for (const feature of features) {
        if (feature.geometry.type === 'Shade') {
            pass.drawer.drawRect(shadeRect, {
                color: layer.paint.dayColor
            });
            const [r, g, b] = parseColor255(layer.paint.nightColor as string);
            const start = xAxis.project(feature.geometry.bounds[0][0], pass.viewState);
            const end = xAxis.project(feature.geometry.bounds[1][0], pass.viewState);
            pass.drawer.beginClip(shadeRect);
            pass.drawer.drawGradientRect(
                new Rect([start, shadeRect.top], { width: end - start, height: 6 }),
                feature.geometry.stops.map(([stop, level]) => [stop, `rgba(${r},${g},${b},${1.0 * level})` as Color])
            );
            pass.drawer.endClip();
            pass.drawer.drawRect(
                shadeRect,
                {
                    color: '#00000000'
                },
                {
                    width: 0.5,
                    color: layer.paint.outlineColor
                }
            );
        }
    }
};

export const drawShadeLayer: VectorDrawFunction<ShadeLayerSpecification> = (pass, features, layer, xAxis, yAxis) => {
    const color = parseColor255(layer.paint?.color ?? '#464646cc');
    for (const feature of features) {
        if (feature.geometry.type === 'Shade') {
            pass.drawer.drawGradientRect(
                new Rect(
                    [
                        xAxis.project(feature.geometry.bounds[0][0], pass.viewState),
                        yAxis.project(feature.geometry.bounds[0][1], pass.viewState)
                    ],
                    [
                        xAxis.project(feature.geometry.bounds[1][0], pass.viewState),
                        yAxis.project(feature.geometry.bounds[1][1], pass.viewState)
                    ]
                ),
                feature.geometry.stops.map(([stop, level]) => [
                    stop,
                    `rgba(${color[0]},${color[1]},${color[2]},${((color[3] / 255) * level).toPrecision(2)})` as Color
                ])
            );
        }
    }
};
